import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { DateUtilities } from '@evorait/pace-core';

@Pipe({
    name: 'formatSapValue',
})
export class FormatSapValuePipe implements PipeTransform {
    public transform(value: string | number | null | undefined): string {
        if (value === null || value === undefined || value === '') return '';
        if (typeof value === 'number') {
            return String(value);
        }

        const trimmedValue = value.trim();

        // Case 1: Convert time in HHMMSS to HH:MM:SS
        if (/^\d{6}$/.test(trimmedValue)) {
            const hh = trimmedValue.slice(0, 2);
            const mm = trimmedValue.slice(2, 4);
            const ss = trimmedValue.slice(4, 6);

            // Validate time ranges
            const h = Number(hh);
            const m = Number(mm);
            const s = Number(ss);

            const isValidTime = h < 24 && m < 60 && s < 60;
            return isValidTime ? `${hh}:${mm}:${ss}` : trimmedValue;
        }

        // Case 2: Parse \/Date(timestamp)\/ format
        const timestamp = this.extractTimestampFromSapDate(trimmedValue);
        if (timestamp !== null) {
            const date = moment(timestamp);
            return date.isValid() ? DateUtilities.formatDate(date) : trimmedValue;
        }

        // Default fallback: return original trimmed string
        return trimmedValue;
    }

    private extractTimestampFromSapDate(value: string): number | null {
        const match = value.match(/^\/Date\((\d+)\)\/$/);
        return match ? parseInt(match[1], 10) : null;
    }
}
